const searchByConstant = (constant, id, key) => {
  return constant.find((item) => item.id === id)[key];
};

export default searchByConstant;
